import { NgModule } from "@angular/core"
import { RouterModule, Routes } from "@angular/router"

import { ErrorComponent } from "../error/error.component"
import { ErrorModule } from "../error/error.module"
import { CollectionStandardComponent } from "./collection-standard/collection-standard.component"
import { SearchCollectionPageComponent } from "./search-collection-page/search-collection-page.component"
import { SearchCollectionPageModule } from "./search-collection-page/search-collection-page.module"
import { CollectionPremiumComponent } from "./collection-premium/collection-premium.component"
import { CollectionPremiumSubcollectionComponent } from "./collection-premium/collection-premium-subcollection/collection-premium-subcollection.component"
import { StudentGateSearchGuard } from "../guards/StudentGateSearch.guard"
import { CollectionPreviewGuard } from "./guards/collection-preview.guard"
import { SubCollectionPreviewGuard } from "./guards/sub-collection-preview.guard"

const collectionRoutes: Routes = [
    {
        path: ":slug/preview",
        component: CollectionStandardComponent,
        canActivate: [CollectionPreviewGuard],
        canDeactivate: [CollectionPreviewGuard],
    },
    {
        path: ":topParentSlug/t/:slug/preview",
        component: CollectionStandardComponent,
        canActivate: [CollectionPreviewGuard],
        canDeactivate: [CollectionPreviewGuard],
    },
    {
        path: ":slug/:sectionURL/:subcollectionURL/preview",
        component: CollectionPremiumSubcollectionComponent,
        canActivate: [SubCollectionPreviewGuard],
        canDeactivate: [SubCollectionPreviewGuard],
    },
    {
        path: ":topParentSlug/t/:parentSlug/:slug/preview",
        component: CollectionStandardComponent,
        canActivate: [CollectionPreviewGuard],
        canDeactivate: [CollectionPreviewGuard],
    },
    {
        path: ":slug/home/preview",
        component: CollectionPremiumComponent,
        canActivate: [CollectionPreviewGuard],
        canDeactivate: [CollectionPreviewGuard],
    },
    {
        path: ":topParentSlug/t/:parentSlug/:slug",
        component: CollectionStandardComponent,
    },
    {
        path: ":topParentSlug/t/:slug",
        component: CollectionStandardComponent,
    },

    {
        path: ":slug",
        component: CollectionStandardComponent,
    },
    {
        path: ":slug/home",
        component: CollectionPremiumComponent,
    },
    {
        path: ":slug/search",
        component: SearchCollectionPageComponent,
        canActivate: [StudentGateSearchGuard],
    },
    {
        path: ":slug/:sectionURL/:subcollectionURL",
        component: CollectionPremiumSubcollectionComponent,
    },
    {
        path: "",
        component: ErrorComponent,
    },
]

@NgModule({
    imports: [RouterModule.forChild(collectionRoutes), ErrorModule, SearchCollectionPageModule],
    exports: [RouterModule],
})
export class CollectionRoutingModule {}
